import { customNodeStyles } from "./customNodeStyles";
import IconNotebook from "./IconNotebook";

const CustomNode = (props) => {

    const {moduleDisplayName, lastRunCompletedTime, lastRunStartTime, status, url} = props.details;

    const handleRedirect = () => {
        window.open(url, '_blank'); 
    };

    return(
       <div style={{
            ...customNodeStyles.nodeConatiner,
            border: status === "Complete" ? "1px solid #24A148" : "1px solid #F0BF0F"
        }}>
            <div style={customNodeStyles.moduleName}>
                {moduleDisplayName}
            </div>
            <div >
                <div style={customNodeStyles.lastRunTitle}>
                    Last Run Completed Time
                </div>
                <div style={customNodeStyles.dateAndTimeDetails}>
                   {lastRunCompletedTime}
                </div>
            </div>
            <div>
                <div style={customNodeStyles.lastRunTitle}>
                    Last Run Start
                </div>
                <div style={customNodeStyles.dateAndTimeDetails}>
                    {lastRunStartTime}
                </div>
            </div>
            <div style={{display: "flex", alignItems: "center"}}>
                <div>
                    <button
                    style={{
                        ...customNodeStyles.statusButton,
                        backgroundColor : status === "SUCCESS" ? "#ACECBE" : "#FCF2CF"
                    }}
                    >
                        {status}
                    </button>
                </div>
                <div style={{marginTop: "12px", padding: "5px", cursor: "pointer", fontSize: "18px"}} onClick={handleRedirect}>
                    <IconNotebook />
                </div>
            </div>
       </div>
    );
};

export default CustomNode;